export default __webpack_public_path__ + "static/media/4.1bc3f8bc.jpg";